import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/libs/utils";
import { User } from "@/types/user";
import { X } from "lucide-react";
import { useFormContext } from "react-hook-form";

type UserBadgeProps = {
  user: User;
  index: number;
  variant: "approvers" | "references";
  size?: "sm" | "lg";
  noPosition?: boolean;
};

export default function UserBadge({
  user,
  index,
  variant,
  size = "lg",
  noPosition = false,
}: UserBadgeProps) {
  const { setValue, getValues } = useFormContext();

  const handleRemoveUser = () => {
    const approvalSteps = getValues("approvalSteps") || [];
    const updatedArr = approvalSteps[index][variant].filter(
      (item: string) => item !== user.user_id
    );
    setValue(`approvalSteps.${index}.${variant}`, updatedArr);
  };

  return (
    <div
      className={cn("px-2 py-[6px] flex items-center rounded-2xl", {
        "gap-1 bg-gray-E hover:bg-gray-E/80": size === "sm",
        "gap-2 bg-dark-red/20 hover:bg-dark-red/15": size === "lg",
      })}
    >
      <Avatar
        className={cn({
          "size-4": size === "sm",
          "size-5": size === "lg",
        })}
      >
        <AvatarImage src={user.img_url} />
        <AvatarFallback>{user?.user_name}</AvatarFallback>
      </Avatar>
      <div className="flex items-center gap-1">
        <span
          className={cn("text-gray-A font-semibold", {
            "text-[10px]": size === "sm",
            "text-xs": size === "lg",
          })}
        >
          {user.user_name}
        </span>
        {!noPosition && (
          <span className="text-dark-red text-[8px] font-semibold">
            {user.position}
          </span>
        )}
      </div>
      <X
        size={8}
        className="text-gray-B cursor-pointer"
        onClick={handleRemoveUser}
      />
    </div>
  );
}
